"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#E9E3FD",
  d: "M3 4h4.667L10 5.167h7v10.889H3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5B2CE8",
  fillRule: "evenodd",
  d: "M2 3.81a.7.7 0 0 1 .7-.7h4.867a.7.7 0 0 1 .435.151L9.433 4.4H17.3a.7.7 0 0 1 .7.7v11.09a.7.7 0 0 1-.7.7H2.7a.7.7 0 0 1-.7-.7zm1.4.7v10.98h13.2V5.8H9.189a.7.7 0 0 1-.436-.152L7.323 4.51z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5B2CE8",
  fillRule: "evenodd",
  d: "M9.744 7.016a.5.5 0 0 1 .64 0l1.524 1.267a.5.5 0 0 1 0 .769l-1.524 1.267a.5.5 0 0 1-.64 0L8.22 9.052a.5.5 0 0 1 0-.77zm-.422 1.651.742.617.742-.617-.742-.617zm-2.118.376a.5.5 0 0 1 .64 0l1.524 1.268a.5.5 0 0 1 0 .768l-1.524 1.268a.5.5 0 0 1-.64 0L5.68 11.079a.5.5 0 0 1 0-.768zm5.08 0a.5.5 0 0 1 .64 0l1.523 1.268a.5.5 0 0 1 0 .768l-1.524 1.268a.5.5 0 0 1-.639 0l-1.524-1.268a.5.5 0 0 1 0-.768zm-5.502 1.652.742.617.742-.617-.742-.617zm5.08 0 .742.617.742-.617-.742-.617zM8.22 12.338l1.524-1.267a.5.5 0 0 1 .64 0l1.524 1.267a.5.5 0 0 1 0 .77l-1.524 1.266a.5.5 0 0 1-.64 0L8.22 13.107a.5.5 0 0 1 0-.769m1.102.385.742.617.742-.617-.742-.617z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=WorkAppFolderColorIcon20.js.map